export default __webpack_public_path__ + "static/media/Neovera-12-eng.9306c02d.jpg";